export enum ECaseFilter {
  ALL = 'ALL',
  TODAY = 'TODAY',
  THIS_WEEK = 'THIS_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  UPCOMING = 'UPCOMING',
  OLDER = 'OLDER',
}